'use strict';

var useVisualState = require('../../motion/utils/use-visual-state.cjs');
var createRenderState = require('./utils/create-render-state.cjs');
var scrapeMotionValues = require('./utils/scrape-motion-values.cjs');

const useHTMLVisualState = /*@__PURE__*/ useVisualState.makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValues.scrapeMotionValuesFromProps,
    createRenderState: createRenderState.createHtmlRenderState,
});

exports.useHTMLVisualState = useHTMLVisualState;
//# sourceMappingURL=use-html-visual-state.cjs.map
